export type Faq = {
  q: string
  a: string
}

export const crmPageFaqs: Faq[] = [
  {
    q: 'What is 1Dash.Pro?',
    a: 'Your own customer database, Powered by HighLevel — one place where every lead, customer and job lives. Included on every plan.',
  },
  {
    q: 'Can I see where every lead stands?',
    a: 'Yes. A pipeline view shows what stage every lead or job is in, so you know who needs a follow-up.',
  },
  {
    q: 'Do I get a full history on each customer?',
    a: 'Yes. Every call, text, email and note is saved on the contact, so anyone on your team can pick up where it left off.',
  },
  { q: 'Can customers book online?', a: 'Yes. An online booking calendar is included on every plan.' },
  { q: 'Can I send estimates and invoices and get paid by text?', a: 'Yes, on Autopilot.' },
  { q: 'Is there a mobile app?', a: 'Yes, on every plan, so your team can work from the job site.' },
  { q: 'How many team members can use it?', a: 'Launch 3, Pilot 5, Co-Pilot 10, Autopilot 20.' },
  {
    q: 'Do you build the automations for me?',
    a: 'Yes. Pipelines and automation are built for you on Autopilot.',
  },
]

export const websitesPageFaqs: Faq[] = [
  { q: 'Do I need to know anything technical?', a: 'No. If you can describe it, you can change it.' },
  {
    q: 'How fast do changes show up?',
    a: 'Most are live within minutes. Bigger changes, like a whole new page, can take a few minutes longer. Refresh your browser if you still see the old page.',
  },
  {
    q: 'What if a change doesn’t go through?',
    a: 'We watch every change until it’s confirmed live. If something holds it up, our system catches it and finishes it. You don’t need to send it again.',
  },
  {
    q: 'Can someone else change my website?',
    a: 'Only people with your 4-digit PIN. Keep it private, and ask us any time for a new one.',
  },
  { q: 'Can I text or call from any phone?', a: 'Use the phone number on your account. That’s how we know it’s you.' },
  {
    q: 'I already have a website. Do I lose it?',
    a: 'No. We rebuild it as a Living Website and switch your web address over when you’re ready.',
  },
  {
    q: 'What exactly is ready in 3 days?',
    a: 'The full site structure, live and viewable, built for your business. Your final photos, exact wording and small tweaks come right after, fast.',
  },
  { q: 'Is there a contract?', a: 'There’s a 3-month minimum term on every plan.' },
  { q: 'Can I keep my own domain?', a: 'Yes. You use and keep your own domain.' },
]

export const pricingPageFaqs: Faq[] = [
  {
    q: 'What does "included usage" cover?',
    a: 'A monthly allowance for calls, texts, WhatsApp and AI inside your account: Launch $5, Pilot $15, Co-Pilot $30, Autopilot $60.',
  },
  { q: 'Does unused usage roll over?', a: 'No. It resets every month.' },
  { q: 'What if I go over?', a: 'Usage beyond your allowance is billed separately.' },
  {
    q: "What's billed separately?",
    a: 'Extra usage, domains, migrations, custom automation builds, voice clone setup, and work outside your package are quoted separately.',
  },
  {
    q: 'Can I pay by ACH or check?',
    a: 'Yes. Prices shown are card prices. Email results@getadroi.com for ACH or check pricing.',
  },
]
